import React, { useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import "../index.css";
import Skeleton from "./skeleton-loader/skeleton";

export { CustomTable };

export default function CustomTable(props) {
  const {
    totalCount=0,
    fetchMoreData,
    pageSize,
    page,
    loading,
    setSelectAllActive,
    selectAllActive = false,
    resetStoreData,
    selectedInput=[],
    setSelectedInput,
    gotoPage,
    selectionColKey,
    selectionColName,
    loadMore,
    checkBoxReq = false,
    allColSort = true,
    sortableCol = [],
  } = props;

  const selectAllInput = (e, hg) => {
    setSelectedInput([]);
    setSelectAllActive(!selectAllActive);
  };
  const extractSelectionValue = (row) => {
    if (Array.isArray(selectionColKey)) {
      return selectionColKey.reduce((acc, key) => {
        acc[key] = row.values[key];
        return acc;
      }, {});
    }
    return row.values[selectionColKey];
  };

  const isRowSelected = (row) => {
    const selectionValue = extractSelectionValue(row);

    if (typeof selectionValue === "object") {
      return selectedInput.some((item) =>
        selectionColKey.every((key) => item[key] === selectionValue[key])
      );
    }

    return selectedInput.includes(selectionValue);
  };

  const handleSelection = (e, row) => {
    const { checked } = e.target;
    const selectionValue = extractSelectionValue(row);

    if (checked) {
      setSelectedInput([...selectedInput, selectionValue]);
    } else {
      setSelectedInput(
        selectedInput.filter((item) =>
          typeof selectionValue === "object"
            ? !selectionColKey.every((key) => item[key] === selectionValue[key])
            : item !== selectionValue
        )
      );
    }
  };

  useEffect(() => {
    if (props.rows.length && loadMore) {
      const scrollHeight =
        document.getElementById("scrollableDiv").scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (scrollHeight <= clientHeight) {
        fetchMoreData();
      }
    }
  }, [props.rows, loadMore]);

  return (
    <>
      <InfiniteScroll
        dataLength={props.rows.length}
        pullDownToRefreshThreshold={50}
        next={!loading && fetchMoreData}
        hasMore={!loading && loadMore}
        height={"100%"}
        scrollableTarget="newOrderTable"
      >
        <table
          id="scrollableDiv"
          {...props.getTableProps()}
          className="display"
          style={{ width: "100%" }}
        >
          <thead className="s">
            {props.headerGroups.map((hg, headerGroupsIndex) => (
              <tr
                {...hg.getHeaderGroupProps()}
                key={headerGroupsIndex + "---" + headerGroupsIndex}
              >
                {checkBoxReq ? (
                  <th style={{ paddingRight: "14px", width: "30px" }}>
                    <input
                      type="checkbox"
                      checked={selectAllActive}
                      onChange={(e) =>
                        selectAllInput(
                          e,
                          props.rows.map((i) => i)
                        )
                      }
                    />
                  </th>
                ) : (
                  <th></th>
                )}
                {hg.headers.map((col, headerIndex) => {
                  const isSortable = allColSort || sortableCol.includes(col.id);
                  return (
                    <th
                      {...col.getHeaderProps(
                        isSortable
                          ? {
                              ...col.getSortByToggleProps(),
                              onClick: (e) => {
                                resetStoreData();
                                col.getSortByToggleProps().onClick(e);
                              },
                            }
                          : {}
                      )}
                      key={headerIndex + "--" + headerIndex}
                    >
                      <div className="th-title relative d-flex align-center">
                        {col.render("Header")}
                        <span className="material-symbols-outlined">
                          {col.isSorted
                            ? col.isSortedDesc
                              ? "arrow_drop_down"
                              : "arrow_drop_up"
                            : ""}
                        </span>
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody {...props.getTableBodyProps()} className="" id="newOrderTable">
            {props.rows.map((row, index) => {
              props.prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={index + "-" + index}>
                  {checkBoxReq ? (
                    <td>
                      <input
                        type="checkbox"
                        checked={selectAllActive || isRowSelected(row)}
                        onChange={(e) => handleSelection(e, row)}
                      />
                    </td>
                  ) : (
                    <td></td>
                  )}
                  {row.cells.map((cell, cellIndex) => {
                    if (
                      cell.column &&
                      (Array.isArray(selectionColName)
                        ? selectionColName.includes(cell.column.Header)
                        : cell.column.Header === selectionColName)
                    ) {
                      return (
                        <td
                          className="cursor-pointer table-td po-num"
                          {...cell.getCellProps()}
                          key={cellIndex + "+" + cellIndex}
                          onClick={() => gotoPage(row, cell)}
                        >
                          {cell.render("Cell")}
                        </td>
                      );
                    } else {
                      return (
                        <td
                          {...cell.getCellProps()}
                          key={cellIndex + "+" + cellIndex}
                        >
                          {cell.render("Cell")}
                        </td>
                      );
                    }
                  })}
                </tr>
              );
            })}
            {loading ? (
              <tr>
                <td
                  colSpan={props.headerGroups[0].headers.length + 1}
                  className="no-records"
                >
                  <div>
                    <div className="overlay2"></div>
                    <div className="pl-3">
                      <Skeleton width="100%" height="35px" />
                    </div>
                  </div>
                </td>
              </tr>
            ) : (
              props.rows.length <= 0 && (
                <tr>
                  <td
                    colSpan={props.headerGroups[0].headers.length + 1}
                    className="no-records"
                  >
                    {loading ? (
                      <div>
                        <div className="overlay2"></div>
                        <div className="pl-3">
                          <Skeleton width="100%" height="35px" />
                        </div>
                      </div>
                    ) : (
                      <div className="no-rec-found d-flex flex-col">
                        <img src="/images/no_search.svg" alt="" />
                        No Record Found
                      </div>
                    )}
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </InfiniteScroll>
      {checkBoxReq && <div className="table-row-counters">Selected <span>{selectAllActive? totalCount :selectedInput.length}</span> of <span>{totalCount}</span></div>}
    </>
  );
}
